import React from 'react';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import axios from 'axios';
// import reqwest from 'reqwest';
import {Modal, Button, message, Icon, Alert, notification, Upload, Progress} from 'antd';
// import styles
import './SetRawFiles.Upload.css';
// import data
import {priviledgedUsers} from '../assets/constants/users';

function setErrorMsg(error) {
  return {
    registerError: error
  }
}

function getFileListSize(filelist){
  let totalSize = 0;
  if (filelist.length > 0){
    filelist.forEach((file)=>{
      totalSize += file.size;
    });
  }
  totalSize = Math.round(totalSize/1000000000*1000)/1000;
  return totalSize;
}
  
class UploadRawFiles extends React.Component{
  constructor(props){
    super(props);
    this.state={
      //show error msg
      registerError: null,
      //show upload modal
      visible: false,
      //file upload info
      fileList: [],
      uploading: false,
      progress: 0,
      //show uploaded info, incomplete yet...
      complete: false,
      uploaded_files: [],
    }
  }
    
  showModal = ()=>{
    this.setState({
      visible: true, 
      registerError: null,
      fileList: [],
      uploading: false,
      progress: 0,
    });
  }

  handleCancel = (e)=>{
    this.setState({
      visible:false,
      registerError: null,
      fileList: [],
      uploading: false,
      progress: 0,
    })
  }

  handleUpload = (e, url, sessID, userEmail)=>{
    const { fileList } = this.state;
    const formData = new FormData();
        
    fileList.forEach((file) => {
      // console.log(file);
      if(priviledgedUsers.indexOf(this.props.userEmail) === -1){
        //upload file size cannot exceed 4G
        if(file.size < 4000000000){
          formData.append('files[]', file);
        }else{
          notification.warning({
            message: 'upload denied',
            description: `${file.name} is larger than 4G, will not be uploaded`, 
          }); 
        }
      }else{
        formData.append('files[]', file);
      }
    });

    //append additional parameters to formData 
    formData.append('sess_id', sessID);
    formData.append('user_email', userEmail);

    // console.log(formData);

    this.setState({
      uploading: true,
      registerError: null,
    });

    // the uploading process using axios, which is simpler
    axios({
      url: url,
      method: 'post',
      data: formData,
      onUploadProgress: (evt => {
        if(evt.lengthComputable){
          // console.log('progress: ' + evt.loaded+ "/" + evt.total);
          let _progress = Math.round(evt.loaded/evt.total*100);
          this.setState({progress: _progress})
        }
      })
    })
    .then(res => {
      // console.log(res);

      this.setState({
        fileList: [],
        uploading: false,
      });

      if(res.data.error.length !== 0){
          this.setState(setErrorMsg(res.data.error));
      }else{
        message.success('Upload successful.');
        this.setState({visible:false,});
      }
    })
    .catch(err => {
      this.setState({
        uploading: false,
        visible: false,
      });
      message.error('Connecting to iMetaLab server failed, unable to upload files.');
    });
    
  }

  updateFilelist=()=>{
    this.props.fetchFilelist(`${this.props.SERVER_APIS.SERVER_URL}${this.props.SERVER_APIS.FETCH_RAWFILELIST}`, this.props.sessID);
  }

  render(){
    //console.log(this.props);
    const {sessID, userEmail, SERVER_APIS} = this.props;
    const {registerError, uploading, fileList, progress, visible} = this.state;

    //console.log(fileList);
    let total_size = getFileListSize(fileList); 

    const props = {
      action: '',
      multiple: true,
      onRemove: (file) => {
        this.setState(({ fileList }) => {
          const index = fileList.indexOf(file);
          const newFileList = fileList.slice();
          newFileList.splice(index, 1);
          return {
            fileList: newFileList,
          };
        });
      },
      beforeUpload: (file) => {
        this.setState(({ fileList }) => ({
          fileList: [...fileList, file],
        }));
        return false;
      },
      //a good place to reset the progress bar
      onChange: (res)=>{
        this.setState({
          progress: 0,
        });
      },
      fileList: fileList,
    }

    return(
    <div>
      <Button type="primary"
        icon="upload"
        onClick={this.showModal}
      >Upload files</Button>

      <Modal title="Upload Files"
        bodyStyle={{}}
        maskStyle={{}}
        width="620px"
        visible={visible}
        onOk={this.handleOk} 
        onCancel={this.handleCancel}
        afterClose={this.updateFilelist}
        footer={null}
      >
        <Alert 
          message="About uploading"
          description={<ul><li>Only 10 files in total can be uploaded for each session, extra files will be ignored.</li><li>File size exceeds 4G will not be uploaded.</li><li>Files with the same name will not be uploaded.</li></ul>}
        />
        {
          registerError &&
          registerError.map((value, index)=>{
            return (<Alert style={{margin: '15px 0px 15px 0px',}} key={index} message={value} type="error" showIcon/>);
          })   
        }
        <div className="upload-components-wrapper">
          <div className="upload-components-wrapper-left">
            <Upload {...props} style={{padding: 15,}}>
              <Button>
                <Icon type="file-add" />Select Files
              </Button>
            </Upload>
            {
              fileList.length === 0
              &&
              <div className="no-file-selected-wrapper">
                <Icon type="file" />
                <span>No file selected</span>
              </div>
            }
            {
              fileList.length > 0
              &&
              <div className="no-file-selected-wrapper">
                <Icon type="copy" />
                <span>{`${fileList.length} files selected with total size of ${total_size}G`}</span>
              </div>
            }
          </div>

          <div className="upload-components-wrapper-right">
            <Progress type="circle" percent={progress} />
          </div>
        </div>

        <div className="upload-button-wrapper">
          <Button
            type="primary"
            icon="upload"
            onClick={(e)=>this.handleUpload(e, `${SERVER_APIS.SERVER_URL}${SERVER_APIS.UPLOAD_RAWFILES}`, sessID, userEmail)}
            disabled={fileList.length === 0}
            loading={uploading}
          >
          {uploading ? 'Uploading' : 'Start Upload' }
          </Button>
        </div>
      </Modal>
    </div>
    );
  }
}

export default UploadRawFiles;